import styled from 'styled-components'

import type { ReleaseInfoModel } from '../../../models/Navbar/ReleaseInfoModel'
import type { OperationStatus } from '../../../models/common/OperationStatus'
import { SvgIcons } from '../../Icon/Icon'
import { Row } from '../../Table/Table'
import type { Instance } from 'mobx-state-tree'
import { observer } from 'mobx-react'

interface ReleaseInfoProps {
  releaseInfo: Instance<typeof ReleaseInfoModel> | null
  fetchStatus: OperationStatus
}

const FlytrexLogoContainer = styled.div`
  margin: 1em 1em;
`

const VersionNumberContainer = styled.div`
  font-weight: bold;
`

export const AboutDialog = observer(({ fetchStatus, releaseInfo }: ReleaseInfoProps) => {
  const releaseInfoText = (
    fetchStatus: OperationStatus,
    value?: string,
  ): string => {
    if (fetchStatus.inProgress) {
      return 'Loading...'
    }
    if (fetchStatus.error) {
      return 'Error loading version'
    }
    return value ?? 'Unknown'
  }
  return (
    <>
      <FlytrexLogoContainer>
        <SvgIcons.FlytrexLogoSmallSvg />
      </FlytrexLogoContainer>
      <Row>
        <span>Frontend version</span>
        <VersionNumberContainer>
          <span>{releaseInfoText(fetchStatus, releaseInfo?.frontend_version)}</span>
        </VersionNumberContainer>
      </Row>
      <Row>
        <span>Backend version</span>
        <VersionNumberContainer>
          <span>{releaseInfoText(fetchStatus, releaseInfo?.backend_version)}</span>
        </VersionNumberContainer>
      </Row>
    </>
  )
})
